export default __webpack_public_path__ + "static/media/attlogo.d15101ec.png";